<template>
  <div
    class="text-input"
    :class="{
      [`text-input--${view}`]: true,
      'text-input--error': errors.length > 0,
    }"
  >
    <label :for="`input-${uniqueID}`" class="text-input__label" v-if="title">
      {{ title }}
    </label>
    <div class="text-input__block">
      <textarea
        :id="`input-${uniqueID}`"
        class="text-input__el"
        :name="name"
        @input="processInput"
        :placeholder="placeholder"
        v-mask="mask"
        v-model="text"
        :autocomplete="autocomplete"
      ></textarea>
      <div class="text-input__errors" v-if="errors.length > 0">
        <div class="text-input__error">
          {{ $t(errors[0].$message ? errors[0].$message : errors[0]) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextArea",
  model: {
    prop: "value",
    event: "update",
  },
  props: {
    name: String,
    title: String,
    placeholder: String,
    value: [String, Number],
    mask: {
      type: [String, Function],
      default: null,
    },
    view: {
      type: String,
      default: "base",
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      text: "",
      uniqueID: "",
    };
  },
  created() {
    this.text = this.value || "";
    this.uniqueID = Math.random().toString(36).substr(2, 9);
  },
  watch: {
    value: function () {
      this.text = this.value;
    },
  },
  methods: {
    processInput() {
      this.$emit("update", this.text);
    },
  },
};
</script>

<style lang="scss" scoped></style>
